"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  default: 'default',
  disabled: 'disabled',
  iows: 'IOWS',
  cartApi: 'CartApi',
  roig: 'roig',
  nifApi: 'NifApi',
  chinaCartApi: 'ChinaCartApi',
  mvecom: 'MvEcom'
};
exports.default = _default;